import { Logger } from "aws-amplify"
import { PhoneNumberFormat, PhoneNumberUtil } from "google-libphonenumber"
import _ from "lodash"

const phoneUtil = PhoneNumberUtil.getInstance()
const logger = new Logger("phone-number")

export const toNationalPhoneNumber = (
  phoneNumber: string,
  regionCode = "ZA",
): string | null => {
  if (_.isEmpty(phoneNumber)) {
    return null
  }

  let nationalPhoneNumber = phoneNumber
  try {
    const number = phoneUtil.parseAndKeepRawInput(phoneNumber, regionCode)
    nationalPhoneNumber = phoneUtil.format(number, PhoneNumberFormat.NATIONAL)
  } catch (err) {
    logger.error(err)
  }
  return nationalPhoneNumber
}

export const toInternationalPhoneNumber = (
  phoneNumber: string,
  regionCode = "ZA",
): string | null => {
  if (_.isEmpty(phoneNumber)) {
    return null
  }

  let nationalPhoneNumber = phoneNumber
  try {
    const number = phoneUtil.parseAndKeepRawInput(phoneNumber, regionCode)
    nationalPhoneNumber = phoneUtil.format(number, PhoneNumberFormat.E164)
  } catch (err) {
    logger.error(err)
  }
  return nationalPhoneNumber
}

export const validatePhoneNumber = (
  phoneNumber: string | null | undefined,
  regionCode = "ZA",
): boolean => {
  if (!phoneNumber || _.isEmpty(phoneNumber)) {
    return false
  }

  try {
    const number = phoneUtil.parseAndKeepRawInput(phoneNumber, regionCode)
    return phoneUtil.isValidNumber(number)
  } catch (err) {
    logger.error(err)
    return false
  }
}
